/**
 * Dostepne statusy transakcji p24
 */
export const P24TransactionStatus = {

    /**
     * nieznany
     */
    UNKNOWN: { id: 0, name: 'UNKNOWN', displayText: 'Nieznany' },
    /**
     * Nowa transakcja, PRZED próbą zarejestrowania w PRZELEWY24.
     */
    NEW: { id: 1, name: 'NEW', displayText: 'Nowa' },
    /**
     * Transakcja została zarejestrowana w PRZELEWY24.
     */
    REGISTERED: { id: 2, name: 'REGISTERED', displayText: 'Zarejestrowana' },
    /**
     * Transakcja została potwierdzona przez PRZELEWY24 poprzez połaczenie się na nasz endpoint.
     */
    NOTIFIED: { id: 3, name: 'NOTIFIED', displayText: 'W trakcie realizacji' },
    /**
     * Transakcja została przez nas zweryfikowana w PRZELEWY24, pieniądze są na koncie klienta.
     */
    VERIFIED: { id: 4, name: 'VERIFIED', displayText: 'Zrealizowana' },

}

/**
 * Kolekcja statusow
 */
export const P24TransactionStatusList = Object.keys(P24TransactionStatus).map(type => P24TransactionStatus[type])

/**
 * Metoda zwracająca status transakcji bazując na identyfikatorze
 * 
 * @param {int} id identyfikator statusu transakcji
 * 
 * @returns {P24TransactionStatus} status transakcji
 */
export const getP24TransactionStatusById = (id) => {
    if (!id) {
        return P24TransactionStatus.UNKNOWN;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let transactionStatus = P24TransactionStatusList.find(item => item.id === id)
    return transactionStatus;
}

/**
 * Czy pokazywać link do zrealizowania płatności
 * 
 * Na ten moment nie pokazujemy tylko dla platnosci zrealizowanej
 * 
 * @param {*} id 
 * 
 * @returns {bool} czy pokazać link do płatności - tylko dla statusu
 */
export const showPayLink = (id) => {
    if (!id) {
        return false;
    }

    if (id === P24TransactionStatus.VERIFIED.id) {
        return false;
    }

    return true;
}